import React from 'react';
import { Layout } from '@/components/layout/Layout';

export default function PrivacyPolicyPage() {
  return (
    <Layout>
      <div className="py-24 px-6 max-w-4xl mx-auto">
        <h1 className="text-4xl font-serif text-foreground mb-8">Privacy Policy</h1>
        <div className="bg-card border border-primary/10 rounded-sm p-8 text-muted-foreground leading-relaxed space-y-4">
          <p>
            Artisan Pizza Talent è gestito da Giacomo Braceschi , con sede a Strasbourg (En cours d'immatriculation).
          </p>
          <p>
            I dati personali sono raccolti esclusivamente per finalità di reclutamento e selezione in conformità al GDPR.
          </p>
          <p>
            Gli utenti possono richiedere la rettifica o cancellazione a <a href="mailto:giacomo@artisanpizzatalent.com" className="text-primary hover:underline">giacomo@artisanpizzatalent.com</a>.
          </p>
        </div>
      </div>
    </Layout>
  );
}